export default __webpack_public_path__ + "9e8f56aa2290f68ad7d4bd23b06cdf99.svg";